export enum AvailableOperationStatus {
    PENDIENTE = 0,
    ACTIVA = 1,
    FINALIZADA = 2,
    DOCUMENTACION_RECHAZADA = 3,
    RECHAZADA = 4,
    CADUCADA = 5,
    CANCELADA = 6,
    PENDIENTE_ENTREGA = 7,
    BLOQUEADA = 8,
    NO_ENTREGADO = 9
}